import React, { useState } from "react";

interface MfaCodeFormProps {
  onSubmit: (code: string, rememberDevice: boolean) => void;
  loading: boolean;
  error?: string | null;
  onBack: () => void;
}

const MfaCodeForm: React.FC<MfaCodeFormProps> = ({ onSubmit, loading, error, onBack }) => {
  const [code, setCode] = useState("");
  const [rememberDevice, setRememberDevice] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (code.length > 0) {
      onSubmit(code, rememberDevice);
    }
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      {error && <div className="text-red-600 mb-2 text-sm text-center">{error}</div>}
      <div>
        <label htmlFor="mfa-code" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
          Enter 6-digit code from your authenticator app
        </label>
        <div className="mt-2">
          <input
            id="mfa-code"
            name="mfa-code"
            type="text"
            autoComplete="one-time-code"
            required
            value={code}
            onChange={e => setCode(e.target.value)}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 placeholder:text-gray-400 dark:placeholder:text-gray-600 focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:focus:ring-indigo-600 sm:text-sm sm:leading-6 text-center tracking-widest font-mono"
            inputMode="text"
          />
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center">
            Enter a 6-digit code from your authenticator app <b>or</b> paste a backup code.
          </p>
        </div>
      </div>
      <div className="flex items-center">
        <input
          id="remember-device"
          name="remember-device"
          type="checkbox"
          checked={rememberDevice}
          onChange={e => setRememberDevice(e.target.checked)}
          className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-600"
        />
        <label htmlFor="remember-device" className="ml-2 block text-sm text-gray-900 dark:text-gray-100">
          Remember this device for 30 days
        </label>
      </div>
      <div>
        <button
          type="submit"
          className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
          disabled={loading || code.length === 0}
        >
          {loading ? "Verifying..." : "Verify Code"}
        </button>
      </div>
      <div className="mt-4 text-center">
        <button
          type="button"
          className="text-indigo-600 hover:underline text-sm"
          onClick={onBack}
        >
          Back to Login
        </button>
      </div>
    </form>
  );
};

export default MfaCodeForm;
